export default __webpack_public_path__ + "static/votes_54-0033c65ac4b0ea769e5db4ac0eacb111.png";